
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, ExecutionResult, GridMetadata } from "@tylertech/tyler-api-types";

/**
 * EmployeeTasksManagerService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeeTasksManagerService<T = unknown> {
    private readonly $apiService = inject(ApiService);
    
    GetEmployeeTaskListAndEmployeeTaskListTaskCodes(pEmployeeId: string): Promise<T> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/GetEmployeeTaskListAndEmployeeTaskListTaskCodes", pEmployeeId);
    }
    GetEmployeeTaskListEntity(): Promise<T> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/GetEmployeeTaskListEntity");
    }
    GetEmployeeTaskListMetaData(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/GetEmployeeTaskListMetaData");
    }
    GetEmployeeTaskListTaskCodeMetaData(): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/GetEmployeeTaskListTaskCodeMetaData");
    }
    GetEmployeeTaskListTaskCodes(pEmployeeTaskModel: T): Promise<T> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/GetEmployeeTaskListTaskCodes", pEmployeeTaskModel);
    }
    SaveEmployeeTaskListData(pEmployeeTaskModel: T): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/SaveEmployeeTaskListData", pEmployeeTaskModel);
    }
    TaskListHasTaskCodes(pTaskListId: string): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/TaskListHasTaskCodes", pTaskListId);
    }
    UpdateEmployeeTaskListData(pEmployeeTaskModel: T): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IEmployeeTasksManagerService/UpdateEmployeeTaskListData", pEmployeeTaskModel);
    }
}
